import { render } from "./CVSpecialties.vue?vue&type=template&id=c851fbc8&scoped=true"
import script from "./CVSpecialties.vue?vue&type=script&lang=js"
export * from "./CVSpecialties.vue?vue&type=script&lang=js"

import "./CVSpecialties.vue?vue&type=style&index=0&id=c851fbc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c851fbc8"]])

export default __exports__